export const translations = {
  es: {
    CAN_ENROLL: {
      TEMPORAL_ACCESS: 'Acceso temporal',
      FREEMIUM: 'Pruébalo ahora',
      MEMBERSHIP: 'Acceso Premium',
      FREE: 'Inscríbete gratis',
      DEFAULT: 'Inscríbete ahora',
    },
    CANNOT_ENROLL: {
      MEMBERSHIP: 'Vuélvete Premium',
      PAID: 'Cómpralo ahora',
      DEFAULT: 'Ver curso',
    },
  },
  pt: {
    CAN_ENROLL: {
      TEMPORAL_ACCESS: 'Acesso temporário',
      FREEMIUM: 'Experimente agora',
      MEMBERSHIP: 'Acesso Premium',
      FREE: 'Inscreva-se grátis',
      DEFAULT: 'Inscreva-se agora',
    },
    CANNOT_ENROLL: {
      MEMBERSHIP: 'Torne-se Premium',
      PAID: 'Compre agora',
      DEFAULT: 'Ver curso',
    },
  },
};
